(function Bookings($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('/Agents/bookings', function onload()
		{
			$('.import').on('click', function _showCalendar(e) {
				$('#import').offcanvas('show');
			});

			$('.linked-pnrs').on('click', function _showLinkedPNRs(e) {
				var reservation_id = $(this).data('id');

				HE.Ajax.get('/Reservations/linkedPnrs/' + reservation_id)
				.then(function _showLinkedPnrs(data) {
					$('#linked_pnrs').offcanvas('show');
					$('#linked_pnr_details').html(data);
					
				});
			});
		});
	});
}(jQuery, window.HE || {}));